import React, {  useState, Fragment } from "react";
import { useTranslation } from "react-i18next";
import {  Box } from "@mui/material";
import DialogContentModal from "../components/DialogContent";
import Form12ApplicaionFormatView from "../../Forms/Form12/Form12ApplicationView";
import PaymentPrint from "@egovernments/digit-ui-module-obps/src/pages/employee/PaymentSlipEmp/PaymentSlip";
import MapSubmissionSummary from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/formComponents/map-submission/Summary/MapSubmissionSummary";

const EmployeeComponent = ({ formData ,applicationDocs,totalAmount,edcrDetails,collectionBillDetails}) => {
    let user = Digit.UserService.getUser();
    const [smShow, setSmShow] = useState(false);
    const [smShowPayment, setSmShowPayment] = useState(false);
    const { t } = useTranslation();
    return (
        <React.Fragment>
            {/* {user?.info?.type !=="CITIZEN" &&( */}
        <div style={{ backgroundColor: "#eeeab5b0" , padding:"10px"}}>
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)">
            <Box gridColumn="span 2">
              <b>{t(`BPA_APPLICATION_NUMBER_LABEL`)}</b>
            </Box>
            <Box gridColumn="span 3">
              : &nbsp;&nbsp; {formData?.applicationNo || ""}
            </Box>
            <Box gridColumn="span 3">
              <button
                className="btn btn-primary"
                style={{padding:"1px"}}
                onClick={() => {
                  setSmShow(true),
                    console.log("modal open")
                }}
              >
                View Application
              </button>
            </Box>
            <Box gridColumn="span 4">
            {formData?.paymentStatus === "Success" && (
              <button
                className="btn btn-primary"
                style={{padding:"1px"}}
                onClick={() => {
                  setSmShowPayment(true),
                    console.log("modal open")
                }}
              >
                Payment Receipt
              </button>
            )}
            </Box>
            <Box gridColumn="span 2">
              <b>Mobile Number</b>
            </Box>
            <Box gridColumn="span 10">
              {formData?.landInfo?.owners && formData?.landInfo?.owners?.map((ob, index) => (
                <div>
                  : &nbsp;&nbsp; {ob?.mobileNumber}
                </div>
              ))}
            </Box>
            <Box gridColumn="span 2" >
            <b>Applicant Name</b>
          </Box>
          <Box gridColumn="span 10">
            {formData?.landInfo?.owners && formData?.landInfo?.owners?.map((ob, index) => (
              <div>
                : &nbsp;&nbsp; {ob?.name}
              </div>
            ))}
          </Box>
            <Box gridColumn="span 2">
              <b>Applied For </b>
            </Box>
            <Box gridColumn="span 10">
              : &nbsp;&nbsp;{t(`${formData?.applicationType}`)}
            </Box>
            <Box gridColumn="span 2">
              <b>Form </b>
            </Box>
            <Box gridColumn="span 10">
            : &nbsp;&nbsp; Permission for Building Plan Approval
            </Box>
          </Box>
          <DialogContentModal
            title={"Application Details"}
            dataOpen={smShow}
            onClose={() => { setSmShow(false) }}
          >
            <MapSubmissionSummary 
                formData={formData}
                applicationDocs={applicationDocs}
                totalAmount={totalAmount}
                edcrDetails={edcrDetails}
                collectionBillDetails={collectionBillDetails}
              />
          </DialogContentModal>

          <DialogContentModal
            title={"Application Payment Details"}
            dataOpen={smShowPayment}
            onClose={() => { setSmShowPayment(false) }}
          >
            <PaymentPrint
              id={formData?.applicationNo}
            />
          </DialogContentModal>

        </div>
        {/* )} */}
         </React.Fragment>
    )
}
export default EmployeeComponent;